<template>
  <div class="stat-card">
    <div class="stat-icon" :class="variant">
      <ExIcon :name="icon" />
    </div>
    <div class="stat-content">
      <span class="stat-label">{{ label }}</span>
      <span class="stat-value">{{ value }}</span>
    </div>
  </div>
</template>

<script>
import ExIcon from "./ExIcon.vue";

export default {
  name: "StatCard",
  components: { ExIcon },
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], required: true },
    icon: { type: String, default: "bar-chart" },
    variant: { type: String, default: "blue" }, // blue | green | purple | orange
  },
};
</script>

<style lang="scss" scoped>
.stat-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 20px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 7px;
  transition: all 0.2s ease;

  &:hover {
    background: #f8fafc;
  }
}

.stat-icon {
  width: 48px;
  height: 48px;
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 24px;

  &.blue {
    background: #eef2ff;
    color: #4f46e5;
  }
  &.green {
    background: #ecfdf5;
    color: #10b981;
  }
  &.purple {
    background: #f3e8ff;
    color: #9333ea;
  }
  &.orange {
    background: #fff3e8;
    color: #f2994a;
  }
}

.stat-content {
  flex: 1;
  min-width: 0;
}

.stat-label {
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
  display: block;
  margin-bottom: 4px;
}

.stat-value {
  font-size: 22px;
  font-weight: 500;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;

  @media (max-width: 640px) {
    font-size: 18px;
  }
}
</style>
